const radii = {
  default: 2,
  large: 4,
  largest: 8,
  round: 9999,
  ellipse: '100%',
};

export default radii;
